function SnackbarApiErrorMessage(props) {
  const { errors } = props;

  if (Array.isArray(errors) && errors.length > 1) {
    return (
      <ul>
        {errors.map(msg => {
          if (msg?.message) {
            return <li key={msg?.message}>{msg?.message}</li>;
          }
          return <li key={JSON.stringify(msg)}>{JSON.stringify(msg)}</li>;
        })}
      </ul>
    );
  }
  if (Array.isArray(errors) && errors.length === 1) {
    if (errors[0]?.message) {
      return errors[0].message;
    }
    return JSON.stringify(errors[0]);
  }

  if (errors?.message) {
    return errors.message;
  }

  if (errors) {
    return errors;
  }

  return 'Error Message Not Available';
}
export default SnackbarApiErrorMessage;
